var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-sm btn-info btn-block",attrs:{"type":"button"},on:{"click":function($event){return _vm.solicitar()}}},[_c('i',{staticClass:"fa fa-download"}),_vm._v(" SOLICITAR CONFIGURAÇÃO\n")])}
var staticRenderFns = []

export { render, staticRenderFns }